<template>
  <div class="form-container">
    <h1>被害と生息一覧</h1>
    <div class="search-toggle" id="search-toggle">
      <button @click="toggleDropdown" class="dropbtn">
        検索条件を表示/非表示
        <span v-if="!isDropdownVisible">▼</span>
        <span v-else>▲</span>
      </button>
      <div class="search-condition" id="search-condition" v-show="isDropdownVisible">
        <table class="search-table">
        <tbody>
          <tr>
            <td><label class="required-label">都道府県</label></td>
            <td><label>:</label></td>
            <td>
              <select v-model="selectedRegion" :disabled="disableRegion">
                <option value="" disabled>都道府県を選択してください</option>
                <option 
                  v-for="region in regions" 
                  :key="region.region_id" 
                  :value="region.region_id">
                  {{ region.region_nm }}
                </option>
              </select>
            </td>
          </tr>

          <tr>
            <td><label>種別</label></td>
            <td><label>:</label></td>
            <td>
              <select v-model="type">
                <option value="" disabled>種別を選択してください</option>
                <option value="1">{{ typeMapping[1] }}</option>
                <option value="3">{{ typeMapping[3] }}</option>
                <option value="4">{{ typeMapping[4] }}</option>
                <option value="9">{{ typeMapping[9] }}</option>
			  </select>
            </td>
          </tr>

          <tr>
            <td><label>獣種</label></td>
            <td><label>:</label></td>
            <td>
              <div class="checkbox-group">
                <div v-for="(chunk, index) in chunkedAnimalConditions" :key="index" class="checkbox-row">
                  <label v-for="condition in chunk" :key="condition" class="checkbox-item">
                    <input type="checkbox" v-model="selectedConditions" :value="condition" />
                    {{ condition }}
                  </label>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td><label for="userIdSearch">利用者ID</label></td>
            <td><label>:</label></td>
            <td>
              <input type="text" v-model="idSearch" maxlength="8" id="userIdSearch" />
            </td>
          </tr>
          <tr>
            <td><label for="regionSelect">確認場所</label></td>
            <td><label>:</label></td>
            <td>
              <select v-model="selectedCity" id="citySelect">
                <option v-for="municipalities in municipalities" :key="municipalities" :value="municipalities">{{ municipalities }}</option>
              </select>
            </td>
          </tr>
          <tr>
            <td><label for="dateFrom">日付</label></td>
            <td><label>:</label></td>
            <td>
              <input type="date" v-model="dateFrom" id="dateFrom" />
              ～ 
              <input type="date" v-model="dateTo" id="dateTo" />
            </td>
          </tr>
        </tbody>
        </table>
        <div class="search-button-container">
          <button @click="{filterItems(); toggleDropdown();}" class="first">検索</button>
        </div>
      </div>
    </div>
    <table><tbody>
	<tr><td class="abc">
  	  <label>件数：{{ dcount }}件</label>
	</td>
	<td class="action-buttons">
      <button @click="deleteButton" class="alert" :disabled="disabled">削除</button>
      <button @click="displayButton" class="usual inactive" :disabled="disabled">表示</button>
	</td></tr>
    </tbody></table>
    <div class="list-table-container" id="app">
      <div>
        <table>
          <thead>
            <tr>
              <th>受付番号</th>
              <th>利用者ID</th>
              <th>氏名</th>
              <th>種別</th>
              <th>獣種</th>
              <th>確認場所</th>
              <th>日付</th>
              <th>選択</th>
            </tr>
          </thead>
          <tbody id="table-body">
            <tr 
              v-for="row in filteredItems" 
              :key="row.no"
              :class="{'highlight-row': (row.directAdminAgency !== this.directAdminAgency)}"
            >
              <td>{{ row.no }}</td>
              <td>{{ row.id }}</td>
              <td>{{ row.nameKanji }}</td>
              <td>{{ typeMapping[row.type] }}</td>
              <td>{{ animalTypeMapping[row.animalType] }}</td>
              <td>{{ row.municipalities }}</td>
              <td>{{ formatDate(row.damageDate) }}</td>
              <td>
                <input 
                  type="checkbox" 
                  v-model="selectedItems" 
                  :value="row"
				  @click="checked"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/styles/Wildlife-list-common.css";
import axios from "axios";
axios.defaults.timeout = process.env.VUE_TIMEOUT||5000;

export default {
  name: "WildlifeDamageList",

  data() {
    return {
	  dcount: 0,
      disabled: false,
      showAll: false,
      items: [],
      regions: [],
      section: '',
	  type: '',
      filteredItems: [],
      selectedItems: [],
      directAdminAgency: '',
      disableRegion: true,
      isDropdownVisible: false,
      selectedRegion: "",
      selectedConditions: [],
      idSearch: '',
      selectedCity: '',
      municipalities: [],
      dateFrom: '',
      dateTo: '',
      animalConditions: [
        "イノシシ", "ニホンジカ", "クマ", "サル", "タヌキ", 
        "アナグマ", "ハクビシン", "アライグマ", 
        "ヌートリア", "鳥類", "その他"
      ],
      typeMapping: {
        "1": "被害",
        "2": "捕獲",
        "3": "目撃",
        "4": "痕跡",
        "5": "わな",
        "9": "その他"
      },
      animalTypeMapping: {
        "01": "イノシシ",
        "02": "ニホンジカ",
        "03": "クマ",
        "04": "サル",
        "05": "タヌキ",
        "06": "アナグマ",
        "07": "ハクビシン",
        "08": "アライグマ",
        "09": "ヌートリア",
        "10": "鳥類",
        "11": "その他"
      }
    };
  },

  computed: {
    chunkedAnimalConditions() {
      const chunkSize = 5;
      return this.animalConditions.reduce((chunks, condition, index) => {
        const chunkIndex = Math.floor(index / chunkSize);
        if (!chunks[chunkIndex]) chunks[chunkIndex] = [];
        chunks[chunkIndex].push(condition);
        return chunks;
      }, []);
    },
  },

  created() {
    const query = this.$route.query;
	if (query.type) this.type=query.type;
    this.selectedConditions = query.selectedConditions ? JSON.parse(query.selectedConditions) : [];
    this.idSearch = query.idSearch || '';
    this.selectedCity = query.selectedCity || '';
    // 現在のローカルタイムを取得
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1; // 現在の月（0始まりではないように調整）
    // 今年度の4月を計算
    const fiscalYear = month >= 4 ? year : year - 1; // 4月以降ならその年、3月までなら前年
    const fiscalMonth = '04'; // 4月
    const fiscalDay = '01'; // 1日
    // 日付と時刻を設定
    this.dateFrom = query.dateFrom || `${fiscalYear}-${fiscalMonth}-${fiscalDay}`;
    this.dateTo = query.dateTo || '';
    this.showAll = query.showAll === 'true' ? true : false;
    this.isDropdownVisible = query.isDropdownVisible === 'true';
    this.section = localStorage.getItem("section");
    this.directAdminAgency = localStorage.getItem("directAdminAgency");
    this.getRegionDetails().then(ret => {
		if (!ret) {
    		this.searchItems().then(() => {
    		  this.filterItems();
    		});
		}
    });
  },

  methods: {
	checked() {
      if(this.selectedItems.length > 0) {
      	this.selectedItems.pop()
	  }
	},
    toggleDropdown() {
      this.isDropdownVisible = !this.isDropdownVisible;
      this.disabled = this.isDropdownVisible;
      this.$router.replace({ name: 'DamageList',
          query: {
              ...this.$route.query,
              isDropdownVisible: this.isDropdownVisible.toString()
          },
      });
    },

    formatDate(dateStr) {
      if (!dateStr) return '不明'; // nullやundefinedの場合は「不明」を返す

      // UTC日時から日本時間に変換
      const date = new Date(dateStr);

      // JST (UTC + 9時間)に変換
      date.setHours(date.getHours() + 9);

      // フォーマット: yyyy年MM月dd日 hh:mm
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 月を2桁に
      const day = String(date.getDate()).padStart(2, '0'); // 日を2桁に
      const hours = String(date.getHours()).padStart(2, '0'); // 時間を2桁に
      const minutes = String(date.getMinutes()).padStart(2, '0'); // 分を2桁に

      return `${year}/${month}/${day}`;
    },

    async searchItems() {
      const token = localStorage.getItem("jwtToken");
      const userId = localStorage.getItem("userId");
      const section = localStorage.getItem("section");

      try {
        // リクエストボディに id を含める
        const requestData = { id: userId, section: section };

        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/api/wildlifeDamage/getList`,
          requestData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 200 && response.data.message === "検索成功") {
          // 新しいトークンがレスポンスヘッダーに含まれている場合
          const newToken = response.headers.get('Authorization');
          if (newToken) {
              localStorage.setItem('jwtToken', newToken.replace('Bearer ', ''));
          }
          // レスポンスの data を items と filteredItems に格納
          this.items = response.data.data;
          console.log(this.items);
          this.filteredItems = [...this.items];
          // 確認場所のリストを取得（種別フィルタリングを適用）
          this.municipalities = ["未選択",...new Set(
              this.items
                .filter((item) => item.type !== "5" && item.type !== "6")
                .map((item) => {
                  return item.municipalities;
                })
              ),
            ];    
          } else {
        	alert("不明なエラーです");
        }
      } catch (error) {
        this.items = [];
        this.filteredItems = [];
		if (error.status==404) {
			return;
		}
        alert(`タイムアウトです、ログインしなおしてください`);
        this.$router.push({ name: 'Login' });
      }
    },

    filterItems() {
      const dateFormat = /^\d{4}-\d{2}-\d{2}$/;

      if (
        (this.dateFrom && !dateFormat.test(this.dateFrom)) ||
        (this.dateTo && !dateFormat.test(this.dateTo)) ||
        (this.dateFrom && this.dateTo && this.dateFrom > this.dateTo)
      ) {
        alert("有効な日付を指定してください");
        return;
      }

      this.filteredItems = this.items.filter((item) => {
		if (this.type && item.type!=this.type) return false;

        // 地域フィルタリング（selectedRegion が空の場合はすべて許可）
        const isRegionMatched = !this.selectedRegion || item.region_Id === this.selectedRegion;

        // 獣種の条件一致を animalTypeMapping を用いて処理
        const isConditionMatched =
          this.selectedConditions.length === 0 ||
          this.selectedConditions.some(
            (condition) => this.animalTypeMapping[item.animalType] === condition
          );

        const isIdMatched = this.idSearch === '' || item.id.toString().includes(this.idSearch);

        const isCityMatched =
          this.selectedCity === '未選択' ||
          this.selectedCity === '' ||
          (item.municipalities && (
            typeof item.municipalities === 'string'
              ? item.municipalities === this.selectedCity
              : item.municipalities.prefecture === this.selectedCity
          ));

        let isDateMatched = false;

        // 被害一覧では日付はdamageDateのみを対象とする
        const itemDateStr = item.damageDate;

        if (itemDateStr) {
          const itemDate = new Date(itemDateStr);
          const fromDate = this.dateFrom ? new Date(this.dateFrom) : null;
          const toDate = this.dateTo ? new Date(this.dateTo) : null;
		  // 日付だけで判断する、時間はJSTにパッチする
		  itemDate.setHours(itemDate.getHours()+9);
          itemDate.setHours(0, 0, 0, 0);
          if (fromDate && toDate) {
            fromDate.setHours(0, 0, 0, 0);
            toDate.setHours(0, 0, 0, 0);
            isDateMatched = itemDate >= fromDate && itemDate <= toDate;
          } else if (fromDate) {
            fromDate.setHours(0, 0, 0, 0);
            isDateMatched = itemDate >= fromDate;
          } else if (toDate) {
            toDate.setHours(0, 0, 0, 0);
            isDateMatched = itemDate <= toDate;
          } else {
            isDateMatched = true; // 両方未指定の場合はすべて許容
          }
        }

        // 種別フィルタリング（被害、捕獲、目撃、痕跡、その他を表示）
        const isTypeMatched = ['1', '2', '3', '4', '9'].includes(item.type);

        // 削除フラグの条件追加
        const isDeleteFlagMatched = item.deleteFlg !== '1';

        // わなと柵を除外
        const isTrapOrFenceExcluded = !['5', '6'].includes(item.type);

        return (
          isRegionMatched &&
          isConditionMatched &&
          isIdMatched &&
          isCityMatched &&
          isDateMatched &&
          isTypeMatched &&
          isDeleteFlagMatched &&
          isTrapOrFenceExcluded
        );
      });

      // 検索条件をURLに反映
      this.$router.replace({ name: 'DamageList',
        query: {
          selectedConditions: JSON.stringify(this.selectedConditions),
          idSearch: this.idSearch,
          selectedCity: this.selectedCity,
          dateFrom: this.dateFrom,
          dateTo: this.dateTo,
          showAll: this.showAll.toString(),
          isDropdownVisible: this.isDropdownVisible.toString(),
        },
      });
		this.dcount = this.filteredItems.length;
    },

    displayButton() {
      if (!this.selectedItems.length) {
        alert("項目を選択してください");
        return;
      }
      console.log(this.searchItems)
      this.$router.push({ name: 'DamageDetail', 
        query: { data: encodeURIComponent(JSON.stringify(this.selectedItems)) } 
      });
    },

    async getRegionDetails() {
      const token = localStorage.getItem("jwtToken");
      const userId = localStorage.getItem("userId");
      const section = localStorage.getItem("section");
      const regionId = localStorage.getItem("regionId");

      try {
        // リクエストボディに id を含める
        const requestData = { id: userId };

        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/api/regionSearch/getList`,
          requestData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 200) {
          // システム管理者のみ利用可能
          if (section !== '0000') {
            this.disableRegion = true;
            this.regions = response.data.data.filter(org =>
              org.region_id === regionId
            );
            this.selectedRegion = this.regions[0].region_id
          } else {
            this.disableRegion = false;
            this.regions = response.data.data;
          }
          // 新しいトークンがレスポンスヘッダーに含まれている場合
          const newToken = response.headers.get('Authorization');
          if (newToken) {
              localStorage.setItem('jwtToken', newToken.replace('Bearer ', ''));
          }
        } else {
        	alert("不明なエラーです");
        	return true;
        }
      } catch (error) {
        alert(`タイムアウトです、ログインしなおしてください`);
        this.$router.push({ name: 'Login' });
        return true;
      }
      return false;
    },
    
    async deleteButton() {
      const token = localStorage.getItem("jwtToken");
      const section = localStorage.getItem("section");
      
      if (!this.selectedItems.length) {
        alert("項目を選択してください");
        return;
      }

      if (this.selectedItems.length > 1) {
        alert("削除時は複数選択できません");
        return;
      }

      if ((section !== '0000') && (this.selectedItems[0].directAdminAgency !== this.directAdminAgency)) {
        alert("所属行政機関のデータは削除できません");
        return;
      }

      const confirmDelete = confirm("本当に削除しますか");
      if (!confirmDelete) {
        return; // キャンセルの場合は処理を終了
      }

      try {
        const selectedItem = this.selectedItems[0]; // 選択された項目（1つのみ）
        const deleteItem = {
          primaryKey: {
            region_Id: selectedItem.region_Id,
            no: selectedItem.no,
            id: selectedItem.id
          }
        };

        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/api/wildlifeDamageMap/delete`,
          deleteItem,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        // ステータスコード200の場合（送信成功）
        if (response.status === 200) {
          // 新しいトークンがレスポンスヘッダーに含まれている場合
          const newToken = response.headers.get('Authorization');
          if (newToken) {
              localStorage.setItem('jwtToken', newToken.replace('Bearer ', ''));
          }
          alert("データが削除されました");
        } else {
        	alert("不明なエラーです");
        }
      } catch (error) {
        alert(`タイムアウトです、ログインしなおしてください`);
        this.$router.push({ name: 'Login' });
		return;
      }

      this.searchItems().then(() => {
        this.filterItems();
      });
      // 選択ボックスをクリア
      this.selectedItems = [];
    }
  }
};
</script>

<style scoped>
.highlight-row {
  color: red;
}
.usual { background-color: #17a2b8; padding: 6px 20px; }
.first { background-color: #28a745; }
.alert { background-color: #ff6347; }
.abc{
  margin: 15px;
  padding: 5px;
  vertical-align: bottom;
}
</style>
